module.exports = "//static.hsappstatic.net/ContentComponents/static-2.70305/img/payment_methods.png"